// extracted by mini-css-extract-plugin
module.exports = {"shareLinkDetailForm":"index_shareLinkDetailForm_3Ul4F","formButtonGroup":"index_formButtonGroup_Gp9y0"};